var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser3Fill = function SvgUser3Fill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.3 21a7.2 7.2 0 1 1 14.4 0zm7.2-8.1a5.4 5.4 0 0 1-5.4-5.4 5.4 5.4 0 0 1 5.4-5.4 5.4 5.4 0 0 1 5.4 5.4c0 2.983-2.416 5.4-5.4 5.4"
  })));
};
export default SvgUser3Fill;